import { render, staticRenderFns } from "./ApprovalWorkflowHistorical.vue?vue&type=template&id=5db5446e&scoped=true"
import script from "./ApprovalWorkflowHistorical.vue?vue&type=script&lang=js"
export * from "./ApprovalWorkflowHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db5446e",
  null
  
)

export default component.exports